import React from 'react';
import { required, SelectInput } from 'react-admin';
import { useGetList } from 'ra-core';
import { makeStyles } from '@material-ui/core/styles';

const useSelectInputStyles = makeStyles({
    SelectInput: {
        width: '100%',
    },
});

const roleNameMapping = {
    '00000005-0005-0005-0005-000000000005': 'Organization Admin',
    '00000006-0006-0006-0006-000000000006': 'Developer',
};

export const RoleSelectInput = props => {
    const { data, loaded } = useGetList('roles', {
        page: 1,
        perPage: 200,
    });
    const initialValue = props.record?.access[0]?.roleUuid;
    const selectInputClasses = useSelectInputStyles();
    const roleList = Object.values(data).map(choice => {
        const name = roleNameMapping[choice.id];
        if (choice.name !== 'orgpublishers')
            return {
                id: choice.id,
                name: name,
            };
    });
    React.useEffect(() => {
        if (roleList) console.log('roleList : ', roleList);
    }, [roleList]);

    if (!loaded) {
        return null;
    }
    return (
        <SelectInput
            source="roleName"
            initialValue={initialValue}
            label="Roles"
            choices={roleList}
            validate={required()}
            className={selectInputClasses.SelectInput}
            onChange={e => props.onChange(e.target.value)}
        />
    );
};
